<form
  [formGroup]="form"
  (ngSubmit)="handleSubmitButtonClick()">
  <app-form-control label="Dzień obciążenia karty">
    <div class="mb-3 flex">
      <div class="me-auto">
        {{ minRangeValue }}
      </div>

      <div class="mx-auto font-bold">
        {{ currentCardChargeDay() }}
      </div>

      <div class="ms-auto">
        {{ maxRangeValue }}
      </div>
    </div>

    <p-slider
      [formControl]="form.controls.cardChargeDay"
      [step]="1"
      [min]="minRangeValue"
      [max]="maxRangeValue" />
  </app-form-control>

  @if (shouldShowStandardDayMessage()) {
    <app-warning>
      Próby obciążenia karty będą podejmowane w standardowe dni miesiąca — 5.,
      6., 8. lub 11. dnia — aż do pierwszego skutecznego pobrania.
    </app-warning>
  }

  @if (shouldShowConcreteDayMessage()) {
    <app-warning>
      Próbę pobrania środków z karty podejmiemy tylko raz w miesiącu — dokładnie
      {{ currentCardChargeDay() }} dnia.
    </app-warning>
  }

  @if (shouldShowNextMonthMessage()) {
    <app-warning>
      Dzień {{ currentCardChargeDay() }} już minął — obciążenie karty nastąpi w
      kolejnym miesiącu.
    </app-warning>
  }

  <div class="flex justify-end gap-3">
    <p-button
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      type="submit" />
  </div>
</form>
